import { computed, isRef, unref } from 'vue';

import { toSnakeCase } from '@bv/helpers/common';
import { trans } from '@bv/utils';

import type { ErrorObject } from '@vuelidate/core';

export function useLocalizedErrorMessage(error: ErrorObject | undefined) {
  const localizeErrorMessage = computed(() => {
    if (!error || !trans) {
      return '';
    }

    const { $validator, $message, $params } = error;

    // ✅ normalize validator name
    const normalizedValidator = toSnakeCase($validator);
    const messageKey = `validations.${normalizedValidator}_trans`;

    let message = trans(messageKey, $params || {});

    // fallback to default message if translation missing
    if (message === messageKey) {
      message = (isRef($message) ? unref($message) : $message) || $validator;
    }

    return message;
  });

  return { localizeErrorMessage };
}
